export enum SitzTyp {
  Normal,
  PartnerRechts,
  PartnerLinks,
  Platzhalter
}
